import { getRandomInt } from '@/utilities';
import Activity from '@/models/Activity';

export default class ProcessTask extends Activity {
  constructor({ reference }) {
    super({ reference });
  }

  // eslint-disable-next-line class-methods-use-this
  execute() {
    const { task } = this.reference;
    this.reference.increaseFatigueLevel();

    if (task.constructor.name !== 'Bug' && !task.hadMeeting && getRandomInt(1, 10) > 9) {
      this.reference.holdMeeting();
      return;
    }

    if (task.constructor.name === 'Bug' && !task.isChecked) {
      if (this.reference.skills.checkBugSolver.chooseTeam() !== this.reference.team.type) {
        this.finish();
        return;
      }
    }

    if (task.constructor.name === 'Bug' && this.reference.task.debugTimes >= 3) {
      this.reference.task.verify();
      this.finish();
      return;
    }

    task.update(this.reference.productivityPerTick);
    if (task.isFinished) {
      this.finish();
    }
  }

  finish() {
    if (this.reference.task.constructor.name === 'Bug' && this.reference.skills.verifyBug) {
      this.reference.skills.verifyBug.verify();
      return;
    }
    this.reference.placeTask();
  }
}
